import React from 'react';
import './AboutWFAEveryday.scss';
import Slider from 'react-slick';
import { renderSlides } from './util/renderSlides';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';

/**
 * Renders About WFA Everyday module
 * @param {string} title
 * @param {string} ctaText
 * @param {string} ctaLink
 * @param {array} slides
 * @returns {JSX.Element}
 * @constructor
 */
const AboutWFAEveryday = ({ title, ctaText, ctaLink, slides }) => {
  const settings = {
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: true,
        },
      },
    ],
  };

  return (
    <div className="c-about-wfa-everyday background-color-white">
      <div className="c-about-wfa-everyday__inner">
        <div className="c-about-wfa-everyday__title h2-roobert color-black">
          <h2>{title}</h2>
        </div>
        <div className="c-about-wfa-everyday__slides-container-fluid">
          <div className="c-about-wfa-everyday__slides-container">
            <Slider {...settings} className="c-about-wfa-everyday__slides">
              {renderSlides(slides)}
            </Slider>
          </div>
        </div>
        <div className="c-about-wfa-everyday__cta">
          <CTAButton
            type={'secondary'}
            link={ctaLink}
            text={ctaText}
            target={'_self'}
            additionalClasses={'cta color-black'}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutWFAEveryday;
